;(function() {
  'use strict'

  angular.module('core.questionTemplatesEditor', [])
})()
